"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var styles_1 = require("@material-ui/core/styles");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../config/constants"));
var menu_1 = require("../menu");
var styles_2 = __importDefault(require("./styles"));
var AccountScreen = function (_a) {
    var changeSection = _a.changeSection;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var account = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }).account;
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: __assign(__assign({}, theme.typography.body2), { padding: theme.spacing(0, 2), gap: '2px' })
    };
    var handleNavigate = function (section) { return function () {
        var menuItem = (0, menu_1.findInMenuItems)(section);
        if (menuItem) {
            changeSection(menuItem);
        }
    }; };
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 3, direction: "column" },
        react_1.default.createElement(Grid_1.default, { item: true },
            (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(Typography_1.default, { style: labelProps.labelStyle }, "E-mail",
                labelProps.isRequiredLabel ? ' *' : '')),
            react_1.default.createElement(TextField_1.default, { id: "Email", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Email' : null, autoComplete: "Email", className: classes.field, value: account.email, variant: constants_1.default.FIELDS_VARIANT, InputProps: {
                    endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                        react_1.default.createElement(IconButton_1.default, { "aria-label": "Edit email", onClick: handleNavigate(menu_1.SettingsSectionKeys.CHANGE_EMAIL) },
                            react_1.default.createElement(Edit_1.default, null)))),
                    'aria-required': true
                }, helperText: t('account.changeEmailHelper') })),
        react_1.default.createElement(Grid_1.default, { item: true, style: { display: 'flex', justifyContent: 'center' } },
            react_1.default.createElement(Button_1.default, { size: "large", variant: "text", color: "primary", onClick: handleNavigate(menu_1.SettingsSectionKeys.CHANGE_PASSWORD), "aria-label": "Change Password", style: { textTransform: 'uppercase' } }, t('account.changePassword'))),
        react_1.default.createElement(Grid_1.default, { item: true, style: { display: 'flex', justifyContent: 'center' } },
            react_1.default.createElement(Button_1.default, { size: "large", variant: "text", color: "primary", onClick: handleNavigate(menu_1.SettingsSectionKeys.DEACTIVATE_ACCOUNT), "aria-label": "Deactivate Account", style: { textTransform: 'uppercase' } }, t('account.deactivateAccount')))));
};
exports.default = AccountScreen;
//# sourceMappingURL=index.js.map